module.exports = __webpack_public_path__ + "img/new_all.8a605785.svg";